import { useEffect, useRef, useState } from "react";
import LocalStorage from "../helpers/localstorage";
import { FiMessageCircle, FiSend, FiX, FiStar } from "react-icons/fi";
import "../styles/ai-assistant.css";

const AI_URL =
  "https://apiwhattsdom-n8n.znwkmn.easypanel.host/webhook/091329fe-b065-43f4-b055-ae9fea79c957";

type Message = {
  sender: "user" | "bia";
  text: string;
};

// transforma links em <a>
function linkify(text: string) {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  return text.split(urlRegex).map((part, i) => {
    if (part.match(urlRegex)) {
      return (
        <a
          key={i}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          className="bia-link"
        >
          {part}
        </a>
      );
    }
    return part;
  });
}

export default function AIAssistant() {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState<Message[]>([
    { sender: "bia", text: "Olá! Sou a BIA. Como posso te ajudar hoje?" },
  ]);


  const localStorage = new LocalStorage();
  const token = String(localStorage.getAuthToken());


  const chatRef = useRef<HTMLDivElement>(null);

  // 🔥 AUTO SCROLL
  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTop = chatRef.current.scrollHeight;
    }
  }, [messages, loading]);

  const sendMessage = async () => {
    if (!input.trim()) return;

    const userMessage = input;
    setInput("");

    setMessages((prev) => [...prev, { sender: "user", text: userMessage }]);

    try {
      setLoading(true);

      const res = await fetch(AI_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token: token ,message: userMessage }),
      });

      const data = await res.json();

      setMessages((prev) => [
        ...prev,
        { sender: "bia", text: data.message || "Não entendi, pode repetir?" },
      ]);
    } catch (err) {
      console.error("Erro BIA:", err);
      setMessages((prev) => [
        ...prev,
        { sender: "bia", text: "Erro ao conectar com a BIA 😢" },
      ]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bia-root">
      <button
        type="button"
        className="bia-fab"
        onClick={() => setOpen(!open)}
        aria-label={open ? "Fechar assistente BIA" : "Abrir assistente BIA"}
      >
        <FiMessageCircle />
        <span>BIA</span>
      </button>

      {open && (
        <section className="bia-panel" aria-label="BIA Assistente Inteligente">
          <header className="bia-header">
            <div className="bia-header-left">
              <span className="bia-avatar"><FiStar /></span>
              <div>
                <strong>BIA</strong>
                <small>Assistente Inteligente</small>
              </div>
            </div>
            <button type="button" className="bia-close" onClick={() => setOpen(false)} aria-label="Fechar">
              <FiX />
            </button>
          </header>

          <div ref={chatRef} className="bia-messages">
            {messages.map((msg, i) => (
              <div key={i} className={`bia-row ${msg.sender === "user" ? "user" : "bia"}`}>
                <div className={`bia-bubble ${msg.sender === "user" ? "user" : "bia"}`}>{linkify(msg.text)}</div>
              </div>
            ))}

            {loading && (
              <div className="bia-row bia">
                <div className="bia-bubble bia">
                  <span className="bia-typing-label">BIA está digitando</span>
                  <span className="bia-typing-dots"><i /><i /><i /></span>
                </div>
              </div>
            )}
          </div>

          <footer className="bia-input-wrap">
            <input
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && sendMessage()}
              placeholder="Digite sua pergunta..."
              className="bia-input"
            />
            <button type="button" onClick={sendMessage} className="bia-send-btn" disabled={loading || !input.trim()}>
              <FiSend />
              <span>Enviar</span>
            </button>
          </footer>
        </section>
      )}
    </div>
  );
}
